<div class="d-flex">
    <div class="contentBox">
        <h4 [title]="task?.title">{{task?.title}}</h4>
    
        <div class="d-flex align-items-center justify-content-center">
            <div *ngIf="task.assignedId || loggedInUser?.isAdmin" class="w-auto timer">
                <p class="mb-0" (click)="beforeToggle()">{{trackingTotal}}</p>
                <i class="mdi mdi-play text-success"
                    *ngIf="running == false && ('projects:board:tasks:create' | hasPermission)"
                    (click)="beforeToggle()"></i>
                <i class="mdi mdi-pause text-warning"
                    *ngIf="running == true && ('projects:board:tasks:create' | hasPermission)" (click)="beforeToggle()"></i>
            </div>
        </div>
    </div>
    <div class="contentBox2">
        <div class="d-flex">
            <i [title]="translateService.instant('BOARD.PROJECT.PROJECT')" class="mdi mdi-application-brackets" (click)="goToProject()"></i>
            <!-- <button type="button" (click)="goToProject()" class="btn waves-light w-100 btn-secondary searchiconBtn">
                {{'PROJECTS.PROJECT' | translate}}
            </button> -->
        </div>
        <div class="d-flex mt-1">
            <i [title]="translateService.instant('BOARD.TASK')" class="mdi mdi-file" (click)="goToTask()"></i>
            <!-- <button type="button" (click)="goToTask()" class="btn waves-light w-100 btn-secondary searchiconBtn">
                {{'BOARD.TASK' | translate}}
            </button> -->
        </div>
    </div>
</div>
<hr class="solid">